import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CompanyList from "../Components/Customers/CompanyList";
import UsersList from "../Components/Customers/UserList";
import UserSearchCountList from "../Components/Customers/UserSearchCountList";
import "../assets/css/Customers.css";

const pathToTab = {
  "/customer/companies": "Company",
  "/customer/users": "Users",
  "/customer/search-count": "UserSearchCount",
};

const tabToPath = {
  Company: "/customer/companies",
  Users: "/customer/users",
  UserSearchCount: "/customer/search-count",
};

export default function CustomerPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Initialize activeTab from current URL
  const [activeTab, setActiveTab] = useState(() => {
    return pathToTab[location.pathname] || "Company";
  });

  // Sync URL when activeTab changes — now safe!
  useEffect(() => {
    const targetPath = tabToPath[activeTab];
    if (targetPath && location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [activeTab, navigate, location.pathname]); // tabToPath is stable, no need to include

  const renderContent = () => {
    switch (activeTab) {
      case "Company":
        return <CompanyList />;
      case "Users":
        return <UsersList />;
      case "UserSearchCount":
        return <UserSearchCountList />;
      default:
        return <CompanyList />;
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="customer-page">
      <div className="customer-header">
        <div className="tab-buttons">
          <button
            className={activeTab === "Company" ? "active" : ""}
            onClick={() => handleTabChange("Company")}
          >
            Company
          </button>

          <button
            className={activeTab === "Users" ? "active" : ""}
            onClick={() => handleTabChange("Users")}
          >
            Users
          </button>

          <button
            className={activeTab === "UserSearchCount" ? "active" : ""}
            onClick={() => handleTabChange("UserSearchCount")}
          >
            User's Search Counts
          </button>
        </div>
      </div>

      <div className="customer-content">{renderContent()}</div>
    </div>
  );
}